import BackendService from "../../../backend/controller/BackendService";
import CharacterModel from "../../../characters/model/CharacterModel";
import PlayerModel from "../../../player/model/PlayerModel";
import Conversation from "../../model/Conversation";
import LlmConversationMessage from "../../model/LlmConversationMessage";
import ConversationState from "./ConversationState";
import PlayerTurnConversationState from "./PlayerTurnConversationState";

export default class StartingTurnConversationState extends ConversationState {
    /**
     * 
     * @param {string} chapterId
     * @param {Conversation} conversation 
     * @param {CharacterModel[]} characters 
     * @param {BackendService} backendService 
     * @param {PlayerModel} playerModel
     * @returns {Promise<ConversationState>}
     */
    async execute(chapterId, conversation, characters, backendService, playerModel) {
        const nextState = new PlayerTurnConversationState();
        return Promise.resolve(nextState);
    }
}